export const V_ALIGN = {
    TOP: 'Top',
    CENTER: 'Center',
    BOTTOM: 'Bottom'
}

export const H_ALIGN = {
    LEFT_FF: 'Left-FF',
    LEFT_LH: 'Left-LH',
    LEFT_RH: 'Left-RH',
    RIGHT_FF: 'Right-FF',
    RIGHT_LH: 'Right-LH',
    RIGHT_RH: 'Right-RH',
    CENTER_FF: 'Center-FF',
    CENTER_LH: 'Center-LH',
    CENTER_RH: 'Center-RH',
    FF: 'FF',
    LH: 'LH',
    RH: 'RH',
    CENTER: 'Center',
    LEFT: 'Left',
    RIGHT: 'Right',
    JUSTIFY: 'Justify',
}

export const TEXT_ALIGNMENTS = [
  { text: 'left', value: 'left' },
  { text: 'center', value: 'center' },
  { text: 'right', value: 'right' },
  { text: 'justify-inter-word', value: 'justify' },
  { text: 'justify inter character', value: 'justify-inter-char' },
  { text: 'justify inter character (overflow special chars)', value: 'justify-inter-char-overflow' },
];
export const MULTI_LINE_ALIGNMENTS = [
  {value: 'left,top', text: '┍ left, top'},
  {value: 'center,top', text: '┯ center, top'},
  {value: 'right,top', text: '┑ right, top'},
  {value: 'left,center', text: '┡ left, center'},
  {value: 'center,center', text: '╇ center, center'},
  {value: 'right,center', text: '┥ right, center'},
  {value: 'left,bottom', text: '┕ left, bottom'},
  {value: 'center,bottom', text: '┻ center, bottom'},
  {value: 'right,bottom', text: '┙ right, bottom'},
  {text: 'justify-inter-word', value: 'justify'},
  {text: 'justify inter character', value: 'justify-inter-char'},
  {text: 'justify inter character (overflow special chars)', value: 'justify-inter-char-overflow'},
]

export function handleVerticalAlignment(textObj, verticalAlign, availableSpace) {
  if (!verticalAlign) {
    return 0;
  }

  if (availableSpace <= 0) {
    textObj.verticalOffset = 0;
    return 0;
  }

  let topOffset = 0;

  switch(verticalAlign) {
    case 'top':
      topOffset = 0;
      break;
    case 'center':
      topOffset = availableSpace / 2;
      break;
    case 'bottom':
      topOffset = availableSpace;
      break;
  }

  topOffset = Math.round(topOffset);
  textObj.verticalOffset = topOffset;

  return topOffset;
}
